import { createApp } from 'vue'
import App from './App.vue'
import { router } from './router'
import { i18n, setLocale, type Locale } from './i18n'
import './styles/main.css'

const app = createApp(App)
app.use(router)
app.use(i18n)

setLocale(i18n.global.locale.value as Locale)

app.mount('#app')
